import { render, staticRenderFns } from "./PromotionsItems.vue?vue&type=template&id=46b3a1a4&scoped=true&"
import script from "./PromotionsItems.vue?vue&type=script&lang=js&"
export * from "./PromotionsItems.vue?vue&type=script&lang=js&"
import style0 from "./PromotionsItems.vue?vue&type=style&index=0&id=46b3a1a4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b3a1a4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/betsur.net.ar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46b3a1a4')) {
      api.createRecord('46b3a1a4', component.options)
    } else {
      api.reload('46b3a1a4', component.options)
    }
    module.hot.accept("./PromotionsItems.vue?vue&type=template&id=46b3a1a4&scoped=true&", function () {
      api.rerender('46b3a1a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "themes/tusk/modules/components/pages/parts/target/PromotionsItems.vue"
export default component.exports